/* eslint-disable @typescript-eslint/camelcase */
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { SupportedLanguage } from '../utils/enums'
// eslint-disable-next-line @typescript-eslint/camelcase
import { de, en, id, ko, th, vi, zh_CN, zh_TW } from './'
import { TranslationKey, TranslationMap } from './default'

export type TFn = <T extends keyof TranslationMap>(
  templateKey: T,
) => TranslationMap[T]

export const makeTranslateFn = (translations: TranslationMap): TFn => <
  T extends TranslationKey
>(
  templateKey: T,
) => {
  const translation = translations[templateKey]

  if (!translation) {
    if (templateKey !== undefined) {
      // eslint-disable-next-line no-console
      console.warn('Translation for', templateKey, 'missing')
    }
  }

  return (translation || templateKey) as TranslationMap[T]
}

export interface TProp {
  t: TFn
}

const mapStateToTranslations = createSelector<
  { translations: TranslationMap },
  TranslationMap,
  TProp
>(
  state => state.translations,
  translations => ({
    t: makeTranslateFn(translations),
  }),
)

export const translationsByLanguage: Record<
  SupportedLanguage,
  TranslationMap
> = {
  de,
  en,
  id,
  ko,
  th,
  vi,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
}

export const getTranslations = (language: SupportedLanguage) =>
  translationsByLanguage[language]

export const withTranslations = connect(mapStateToTranslations, () => ({}))
